





























import {Component, Prop, Provide} from 'vue-property-decorator';
import Vue from 'vue';

@Component({})
export default class OptsWithOtherInput extends Vue {
    static COMPONENT_NAME = 'opts-with-other-input'

    @Prop({type: String, required: true}) label!: string
    @Prop({type: String, required: true}) name!: string
    @Prop({type: String, default: 'checkbox'}) type!: 'checkbox' | 'radio'
    @Prop({type: String, default: null}) otherName!: string
    @Prop({type: Object, required: true}) options!: Record<string, string>
    @Prop({type: String, default: 'other'}) otherOptionValue!: string
    @Prop({type: String, default: 'Other'}) otherOptionLabel!: string
    @Prop({type: String, default: 'Please specify'}) otherLabel!: string
    @Prop({type: String, default: 'text'}) otherType!: string
    @Prop({type: Array, default: () => ['required']}) otherValidation!: string[]
    @Prop({type: Object, default: () => ({
            required: 'Please specify'
    })}) otherValidationMessages!: Record<string, string>

    @Provide() showOther: boolean = false
    @Provide() internalDetailsValue: string = ''

    get resolvedOtherName(): string {
        return this.otherName || `${this.name}__other`;
    }

    get optionsWithOther(): { value: string, label: string }[] {
        const {options} = this.$props;
        options[this.otherOptionValue] = this.otherOptionLabel;

        return options;
    }

    handleInput(value: string): void {
        this.showOther = this.type === 'checkbox' ? value.includes(this.otherOptionValue) : value === this.otherOptionValue
    }
}

